// api
import ModelService from '@/services/model.service'
import { mapState } from 'vuex'

export default {
  name: 'Vision',
  data() {
    return {
      // 英语 中文 越南语 柬埔寨语 印尼语
      adIdList: '',
      adIdList_pc: [31, 27, 53, 62, 79],
      adIdList_mp: [33, 29, 93, 95, 97],
      // data
      swiperSlides: [],
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        effect : 'slide',
        loop : true,
        autoplay : {
          delay: 5000,
          disableOnInteraction: false,
        },
      },
    };
  },
  computed: mapState({
    ...mapState(['isPC', 'language', 'LangIndex'])
  }),
  watch: {
    LangIndex: {
      handler(str) {
        this.getAdPictureList();
      },
    },
  },
  mounted() {
    this.switchAdlist();
  },
  methods: {
    // 根据客户端切换广告位id
    switchAdlist() {
      if (this.isPC) {
        this.adIdList = this.adIdList_pc;
      } else {
        this.adIdList = this.adIdList_mp;
      }
      this.getAdPictureList();
    },
    // 根据id获取广告图片
    getAdPictureList() {
      const param = {
        lang: this.language,
        adId: this.adIdList[this.LangIndex],
      };
      ModelService.getbanner(param).then((res) => {
        if (res.code === 0) {
          this.swiperSlides = res.data;
          // this.$set(this.swiperSlides, 0, res.data[0]);
        }
      });
    },
  },
};
